var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('mavon-editor',{model:{value:(_vm.markDownData),callback:function ($$v) {_vm.markDownData=$$v},expression:"markDownData"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }